import { Row } from 'read-excel-file'
import { v4 as uuidv4 } from 'uuid'
import { FROM_XLSX_TO_TENDER_TYPE } from 'consts/procurement-plans'
import { ETenderType } from 'types/tender'
import { CITIES_IN_AZ, CITIES_IN_EN } from 'consts/cities'

export function isValidRow(row: Row) {
  return (
    !!row[1] &&
    !!FROM_XLSX_TO_TENDER_TYPE[row[2] as string] &&
    !!row[3] &&
    !isNaN(Number(row[3])) &&
    !!row[4] &&
    (CITIES_IN_EN.includes(row[4] as string) ||
      CITIES_IN_AZ.includes(row[4] as string)) &&
    !!row[5] &&
    !!row[6] &&
    !isNaN(Number(row[6]))
  )
}

export function rowToProcurementPlanItem(row: Row) {
  return {
    name: row[1],
    method: FROM_XLSX_TO_TENDER_TYPE[row[2] as string] ?? ETenderType.OPEN_TENDER,
    announcementMonth: row[3],
    city: row[4],
    deliveryAddress: row[5],
    executionDurationInDays: row[6],
    id: uuidv4(),
  }
}
